import React, { useEffect } from 'react';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [isOpen, onClose]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" role="dialog" aria-modal="true" aria-label={title} data-id="element-157">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-near-black/70 backdrop-blur-sm" onClick={onClose} data-id="element-158" />

      {/* Modal content */}
      <div className="relative bg-off-white w-full max-w-2xl max-h-[85vh] flex flex-col shadow-2xl z-10" data-id="element-159">
        {/* Header */}
        <div className="flex items-center justify-between px-8 py-5 border-b border-sage/20 flex-shrink-0" data-id="element-160">
          <h2 className="text-2xl font-serif text-near-black" data-id="element-161">{title}</h2>
          <button onClick={onClose} className="w-9 h-9 flex items-center justify-center text-gray-400 hover:text-near-black transition-colors" aria-label="Cerrar" data-id="element-162">
            <X className="w-5 h-5" data-id="element-163" />
          </button>
        </div>

        {/* Scrollable body */}
        <div className="overflow-y-auto px-8 py-6 font-sans text-gray-700 leading-relaxed text-sm space-y-4" data-id="element-164">
          {children}
        </div>

        {/* Footer */}
        <div className="px-8 py-4 border-t border-sage/20 flex-shrink-0" data-id="element-165">
          <button onClick={onClose} className="text-sm font-sans font-medium text-dark-green hover:text-near-black transition-colors" data-id="element-166">
            Cerrar
          </button>
        </div>
      </div>
    </div>;
}